import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { apiPost } from "apis/api";
import Modal from "components/modal";
import commonUtil from "utils/common";
import React, { ChangeEvent, KeyboardEvent, useCallback, useEffect, useRef, useState } from "react";

import 'assets/css/board.scss';
import TagManager from "react-gtm-module";

const ageList = [40, 50, 60, 70];
const genderList = [ {value: 'M', label: '남성'}, {value: 'F', label: '여성'}];
interface ParentProps  {
  strReffer : string;
  str_utm_source : string;
  str_utm_medium : string;
  str_utm_campaign : string;
}
const tagManagerArgs = {
  dataLayer: {
    event: "completeregistration"    
  },
};
const DataBoard = ({strReffer, str_utm_source, str_utm_medium, str_utm_campaign}: ParentProps) => {
  const KOREAN_AND_ENGLISH_REGEX = /[^ㄱ-ㅎ가-힣a-zA-Zㆍ ᆢ]/g;
  
  const nameRef = useRef<HTMLInputElement>(null);
  const cellNumRef = useRef<HTMLInputElement>(null);
  const privateCheckRef = useRef<HTMLInputElement>(null);

	const [pName, setName] = useState("");
	const [pCellNum, setCellNum] = useState("");
	const [pAge, setAge] = useState(0);
	const [pHeight, setHeight] = useState(0);
	const [pGender, setGender] = useState("");
  const [pPrivate, setPrivate] = useState("N");

	const [isOpenBoard, setOpenBoard] = useState<boolean>(false);
  const [isOpenPrivate, setOpenPrivate] = useState<boolean>(false);
  
  const onClickToggle = useCallback(() => {
    setOpenPrivate(!isOpenPrivate);
    if(!isOpenPrivate){
      document.body.style.overflow='hidden';
    }else{
      document.body.style.overflow='auto';
    }

  }, [isOpenPrivate]);

  const handlePress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const regex = /^[0-9\b -]{0,13}$/;
    if (regex.test(e.currentTarget.value)) {
      setCellNum(e.currentTarget.value);
    }
  }

  const inputboxHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "pAge") {
      setAge(Number(value));
    } else if (name === "pGender") {
      setGender(value);
    } else {
      console.log(`unknown input name: ${name}`);
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    
    // 입력된 값에서 한글과 영어를 제외한 모든 문자 제거
    const filteredValue = e.target.value.replace(KOREAN_AND_ENGLISH_REGEX, '');    
    
    setName(filteredValue);
  };


  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    
    if(e.target.value.trim() === ""){

    }else{
      if(!commonUtil.checkPhone(pCellNum)){
        setCellNum("");
        alert("연락처는 휴대폰 번호를 입력하셔야 합니다.");
        
        return false;
      }
    }
  };


	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		// TODO: send data to server

    //console.log(pPrivate);
    
    if(pPrivate === "N"){
      alert("\"개인정보 수집 및 활용동의\" 하셔야 신청 가능합니다.");
      return false;
    }

		let paramData = {
      strRefer : strReffer,
      strName : pName,
      strCellNum : pCellNum,
      IKeywordCode01 : str_utm_source,
      IKeywordCode02 : str_utm_medium,
      IKeywordCode03 : str_utm_campaign,
      strType : 'C',
      intHeight : pHeight,
      strGender : pGender,
      MFrom : 'M',
      MMemo : '',
      intAge : pAge,
      strBirth : '',
      
		};

    //console.log(paramData);

		const setData = async () => {
      try {
        const response = await apiPost<{ strResult: string }>('/micro/member/setMemberData', paramData);
        //console.log(response.strResult);

        if(response.strResult === "Y"){

          setName("");
          setCellNum("");
          setAge(0);
          setHeight(0);
          setGender("");
          
          {/*구글 TagMager Event 처리*/}
          TagManager.dataLayer(tagManagerArgs);

          alert('무료체험 신청이 완료 되었습니다.');

        }else if(response.strResult === "D"){
          alert("이미 신청하셨습니다.")
        }else{
          alert('신청중 문제가 발생하였습니다.');
        }

      } catch (error) {
        console.error(axios.isAxiosError(error) ? error.message : error);
      }
    };

		if(pName === ""){
      alert('이름을 입력해주세요.');
      
      nameRef.current?.focus();

      return false;
    }

    if(pCellNum === ""){
      alert('연락처를 입력해주세요.');
      
      cellNumRef.current?.focus();

      return false;
    }

    if(!commonUtil.checkPhone(pCellNum)){
      alert("연락처는 휴대폰 번호를 입력하셔야 합니다.");

      cellNumRef.current?.focus();

      return false;
    }

    if(pCellNum.length != 11 ){
      alert("연락처는 휴대폰 번호로 11자리로 입력하셔야 합니다.");
      
      cellNumRef.current?.focus();

      return false;
    }

    if(pAge === 0){
      alert('나이를 입력해주세요.');

      return false;
    }
    
    if(pGender === ""){
      alert('성별을 입력해주세요.');

      return false;
    }

		setData();

	}
  
  const handleClose = useCallback(() => {
    //console.log(isOpenPrivate);
    setOpenPrivate(!isOpenPrivate);
  }, []);

  return (
    <>
      <div className="popup" style={{display: isOpenPrivate ? "" : "none"}}>
        <div className="pop-back">

        </div>
        <div className="pop-section" >
          <div className="tit_popup">
            <div>
              개인정보처리방침
            </div>
            <div onClick={onClickToggle}>
              <FontAwesomeIcon icon={faXmark}  />
            </div>
          </div>
          
          <div className="pop-text">
            천호엔케어주식회사(이하 '회사')는 회사가 제공하는 온라인 쇼핑몰 사이트(사이트명 표기: ikeyssuk.com)를 포함한 서비스(이하, '서비스')를 이용하는 이용자님들의 개인정보를 매우 중요하게 생각하며 아래와 같은 개인정보 처리방침을 가지고 있습니다. 이 개인정보처리방침은 개인정보와 관련한 법령 또는 지침의 변경이 있는 경우 갱신되고, 서비스 정책의 변화에 따라 달라질 수 있으니 이용자께서는 천호엔케어 사이트를 방문 시 확인하여 주시기 바랍니다. 회사의 개인정보처리방침은 다음과 같은 내용을 담고 있습니다.
            <div>
              <p className="tit">제 1조. 개인정보 수집 및 이용 </p>
                가. 회사는 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호 관계 법령에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
                <br/>
                <table className="t_table">
                  <colgroup>
                    <col width="30%" />
                    <col width="30%" />
                    <col width="40%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>구분</td>
                      <td>목적</td>
                      <td>수집 항목</td>
                    </tr>               
                    <tr>
                      <td>상담을 위한 수집정보</td>
                      <td>제품 상담 및 문의사항 응대</td>
                      <td>성별, 전화번호 문의하기를 통해 입력하는 자녀 민감정보(성별, 연령, 키 등)</td>
                    </tr>
                    <tr>
                      <td>전화 콜백 신청</td>
                      <td>전화 상담을 위한 콜백 진행</td>
                      <td>전화번호</td>
                    </tr>
                    <tr>
                      <td>이벤트 진행</td>
                      <td>이벤트 및 제품 광고, 홍보</td>
                      <td>성명, 전화번호, 성별, 생년월일,
                        마케팅 정보 수신동의
                        </td>
                    </tr>
                    <tr>
                      <td>배송지 확인</td>
                      <td>청구서, 상품 배송지 확인을 위한 정보</td>
                      <td>
                        성명, 전화번호, 우편물 수령지
                        (본인 이외의 타인에게 직접 배송을 요청할 경우 이름, 주소, 연락처 등 배송에 필요한 개인 식별 정보를 수집하는 것에 대하여 동의합니다.)
                      </td>
                    </tr>
                  
                  </tbody>
                </table>
                - 서비스 이용과정이나 처리 과정에서 자동으로 생성되어 수집될 수 있는 정보: IP Address, 참여일시, 유입경로(참여매체), 쿠키, 방문 일시, 서비스 이용 기록, 이용 정지 기록, 결제 기록 등<br/>
              - 용역 및 재화의 주문 시 수집정보<br/>
              ① 신용카드 결제 시 : 카드사명, 카드번호 등 결제를 위한 정보<br/>
              ② 무통장 입금 및 인터넷 뱅킹 시 : 은행 명, 입금자명 등<br/>
              - 신용카드결제, 계좌이체 및 가상계좌는 토스페이먼트 결제 대행서비스를 이용하고 있습니다.<br/>
              -모든 정보는 동의철회시까지 또는 법령상 의무보존기간까지 보관됩니다. 다만, 부정이용방지를 위한 정보(ID, 불량이용 기록)는 탈퇴 DB에서 1개월 후 삭제 – 부정이용이란 회원 탈퇴 후 재가입, 상품 구매 후 구매취소 등을 반복적으로 행하는 등 회사가 제공하는 할인쿠폰, 이벤트 혜택 등의 경제상 이익을 불법 또는 편법적으로 수취하는 행위, 이용약관에서 금지하는 행위, 명의도용 등 불법 또는 편법행위 등을 포함합니다.<br/> 
                

              나. 회사는 개인정보를 수집·이용목적 이외에 다른 용도로 이를 이용하거나 이용자의 동의 없이 제3자에게 이를 제공하지 않습니다.<br/>
              다. 회사는 다음과 같은 목적으로 개인정보를 수집하여 이용할 수 있습니다. <br/>
              다만, 전자상거래 등에서의 소비자보호에 관한 법률, 국세기본법, 전자금융거래법 등 관계법령에 따라 주민등록번호 및 은행계좌번호의
                수집·보관이 불가피한 경우에는 이용자에게 고지하여 해당 정보를 수집할 수 있습니다.<br/><br/>
            </div>
            <div>
              <p className="tit">제 2조. 개인정보의 처리 및 보유기간</p>
              회사는 법령에 따른 개인정보 처리 및 이용기간 또는 정보주체로부터 개인정볼르 수집 시에 동의 받은 개인정보 처리 및 이용기간 내에서 <br/>
              개인정보를 처리, 보유 합니다.<br/><br/>
              원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다.<br/>
              단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령이 정한 일정한 기간 동안 정보를 보관합니다. 전자상거래등에서의 소비자 보호에 관한 법률 제6조, 동시행령 제6조<br/>
              <br/>
              항목 보유 및 이용 기간<br/>
              - 이름, 나이, 연락처, 성별, 주소, 자녀 정보 등 상담 및 배송을 위한 수집정보 5년<br/>
              - 계약 또는 청약철회 등에 관한 기록 5년<br/>
              - 대금결제 및 재화 등의 공급에 관한 기록 5년<br/>
              - 소비자의 불만 또는 분쟁처리에 관한 기록 3년<br/>
              - 방문에 관한 기록 3개월<br/>
              보유기간을 이용자에게 미리 고지하거나 개별적으로 이용자의 동의를 받은 경우는 동의한 기간<br/>

            </div>
            <div>
              <p className="tit">제 3조. 개인정보 파기절차 및 방법 </p>
              회사는 수집한 개인정보의 이용목적이 달성된 후에는 보관기간 및 이용기간에 따라 해당 정보를 지체없이 파기합니다.<br/>
              파기절차, 방법, 시점은 다음과 같습니다. <br/><br/>
              
              가. 파기절차 및 시점<br/>
              고객이 서비스 가입 등을 위해 기재한 개인정보는 서비스 해지 등 이용목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유(위 개인정보의 보유 및 이용기간 참조)에 따른 보유기간이 경과한 후에 삭제되거나 파기합니다. 일반적으로 잔존하는 채권-채무 관계가 없는 경우 사이트 회원가입 시 수집되어 전자적 파일형태로 관리하는 개인정보는 회원 탈퇴 시점에 바로 삭제 됩니다.<br/>
              <br/> 
              나. 파기방법<br/>
              종이에 출력된 개인정보는 분쇄기로 분쇄 또는 소각하거나 화학약품 처리를 하여 용해하여 파기하고, 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.<br/> 
            </div>
            <div>
              <p className="tit">제 4조. 개인정보의 수집, 이용, 제공에 대한 동의절회, 동의 거부권 및 거부 시 불이익</p>
              가. 상담신청 등을 통한 개인정보의 수집, 이용, 제공에 대해 귀하께서 동의하신 내용을 귀하는 언제든지 철회 하실 수 있습니다. <br/>
              동의철회는 개인정보관리책임자에게 서면, 전화, 이메일(E-mail)등으로 연락하시면 즉시 개인정보파기를 위해 필요한 조치를 취합니다. <br/>
              동의 철회를 하고 개인정보를 파기하는 등의 조치를 취한 경우에는 그 사실을 귀하께 지체없이 통지하도록 하겠습니다.<br/>
              <br/>
              나. 회사는 개인정보의 수집에 대한 동의철회(상담신청)를 개인정보를 수집하는 방법보다 쉽게 할 수 있도록 필요한 조치를 취합니다.<br/><br/>
              
              • 개인정보  파기시점 <br/>
                상담신청 철회를 위한 필요조치 요구 확인 즉시<br/>
                배송 정보  문서보관 의무기간(국세청) 7년 <br/>
              <br/>
              설문조사, 이벤트 등 일시적 목적을 위하여 수집한 경우 당해 설문조사, 이벤트 등이 종료한 때
              상담신청 시 최소한의 개인정보의 수집, 이용과 관련하여 개인정보 제공 및 보관 동의를 거부할 수 있으나, 동의를 거부하실 경우 상담신청이 제한될 수 있음을 알려드립니다.
              <br/><br/>
            </div>
            <div>
              <p className="tit">제 5조. 이용자 및 법정대리인의 권리</p>
              귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. <br/>
            </div>
            <div>
              <p className="tit">제 6조. 이용자의 의무</p>
              이용자는 자신의 개인정보를 보호할 의무가 있으며, 회사의 귀책사유가 없이 상담인 개인정보, 접근매체 등의 양도·대여·분실이나 로그인 상태에서 이용자 본인의 부주의나 브라우저 취약점, 
              관계법령에 의한 보안조치로 차단할 수 없는 방법이나 기술을 사용한 해킹 등 회사가 상당한 주의에도 불구하고 통제할 수 없는 인터넷 상의 문제 등으로 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.<br/>
              <br/> 
              가. 이용자는 자신의 개인정보를 최신의 상태로 유지해야 하며, 이용자의 부정확한 정보 입력으로 발생하는 문제의 책임은 이용자 자신에게 있습니다.<br/>
              <br/>
              나. 타인의 개인정보를 도용하여 회원가입 또는 물품거래 시 이용자 자격 상실과 함께 주민등록법에 의거하여 처벌될 수 있습니다.<br/>
              <br/>
              다. 이용자는 아이디(ID), 비밀번호 등에 대해 보안을 유지할 책임이 있으며 제3자에게 이를 양도하거나 대여할 수 없습니다.<br/>
              이용자는 회사의 개인정보보호정책에 따라 보안을 위해 비밀번호의 주기적 변경에 협조할 의무가 있습니다<br/>
              <br/>
              라. 이용자는 회사의 서비스를 이용한 후에는 반드시 로그인 계정을 종료하고 웹 브라우저 프로그램을 종료해야 합니다.<br/>
              <br/>
              마. 이용자는 “정보 통신망 이용촉진 및 정보보호 등에 관한 법률”, “개인정보보호법”, “주민등록법” 등 기타 개인정보에 관한 법률을 <br/>
              준수하여야 합니다.<br/>
            </div>
            <div>
              <p className="tit">제 7조. 개인 정보의 제 3자 제공</p>
              가. 회사는 정보주체의 개인정보를 이용목적 내에서만 처리하며, 정보 주체의 동의, 법률의 특별한 규정이 있는 경우에만 개인정보를 <br/>
              제 3자에게 제공합니다.<br/> 
              나. 회사는 다음과 같이 개인정보를 제 3자에게 제공하고 있습니다.<br/><br/>
              
              1. ㈜드림인사이트
              • 개인정보를 제공받는 자 : ㈜드림인사이트<br/> 
              • 제공받는 자의 개인정보 이용목적<br/>
              - 제품 홍보 및 개인정보 수집대행<br/>
              - 마케팅 및 광고에 활용 : 신규 서비스 개발 및 특화, 이벤트 등 광고성 정보 제공, 광고 전략 수립
              - 보유이용기간 : 모든 정보는 회원탈퇴 또는 동의철회시까지 또는 법령상 의무보존기간까지 보관됩니다

            </div>
            <div>
              <p className="tit">제 8조. 개인정보의 기술적/관리적 보호 대책</p>
              회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 보호대책을 강구하고 있습니다.<br/>
              <br/> 
              가. 개인정보의 암호화<br/>
              이용자의 비밀번호는 일방향 암호화하여 저장 및 관리되고 있으며, 개인정보의 확인 및 변경은 비밀번호를 알고 있는 본인에 의해서만 가능합니다. 비밀번호는 이용자의 생일, 전화번호 등 타인이 추측하기 쉬운 숫자 등을 이용하지 않도록 비밀번호 생성규칙을 수립하여 적용하고 있습니다. 은행계좌번호 및 신용카드번호 등의 개인정보는 안전한 암호 알고리즘으로 암호화되어 저장 및 관리되고 있습니다.<br/>
              <br/> 
              나. 해킹 등에 대비한 대책<br/>
              회사는 해킹 등 회사 정보통신망 침입에 의해 이용자의 개인정보가 유출되는 것을 방지하기 위해 침입탐지 및 침입차단 시스템을 24시간 가동하고 있습니다. 만일의 사태에 대비하여 모든 침입탐지 시스템과 침입차단 시스템은 이중화로 구성하여 운영하고 있으며 민감한 개인정보는 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.<br/>
              <br/> 
              다. 개인정보 취급자의 최소화 및 교육<br/>
              회사는 회사의 개인정보 취급자를 최소한으로 제한하며, 개인정보 취급자에 대한 교육 등 관리적 조치를 통해 개인정보보호의 중요 성을 인식시키고 있습니다.<br/>
              <br/> 
              라. 개인정보보호 전담부서의 운영<br/>
              회사는 개인정보의 효율적 보호를 위해 전산팀 운영하고 있으며, 개인정보처리방침의 이행사항 및 개인정보 취급 자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정할 수 있도록 노력하고 있습니다.<br/>
            </div>
            <div>
              <p className="tit">제 9조. 개인정보 보호 책임자 및 담당자</p>
              이용자의 개인정보를 보호하고 개인정보와 관련된 궁금증 해결, 불만 처리를 위해 다음과 같이 책임자를 지정하고 운영하고 있습니다.<br/>
              개인정보와 관련된 문의사항이 있으시면 아래의 담당자에게 연락 주시기 바랍니다. 이용자의 문의사항에 신속하고 성실하게 답변해드리겠습니다.<br/><br/>
              정보보호최고책임자 <br/><br/>
              성명 : 손동일 <br/>		
              직급 : 대표이사 <br/>
              Email : sondi@chunhoncare.com<br/>
            </div>
            <div>
              <p className="tit">제 10조. 개인정보침해 관련 상담 신고</p>
              가. 회사는 이용자의 의견을 소중하게 생각하며, 이용자는 의문사항으로부터 언제나 성실한 답변을 받을 권리가 있습니다.<br/> 
              회사는 이용자와의 원활한 의사소통을 위해 개인정보보호센터를 운영하고 있습니다. 개인정보보호센터의 연락처는 다음과 같습니다.
              <br/>[개인정보보호센터]<br/>
              - 전자우편: help@chunhoncare.com<br/>
              - 전화번호: 051-303-1005<br/>
              - 팩스번호: 051-303-1586<br/>
              - 주 소: 부산광역시 부산진구 중앙대로 770 (부전동) 고촌빌딩, 2층 (주)천호엔케어<br/>
              전화상담은 평일 오전 09:00 ~ 오후 07:00 까지 가능합니다.<br/>
              전자우편이나 팩스 및 우편을 이용한 상담은 접수 후 24시간 내에 성실하게 답변 드리겠습니다. 다만, 근무시간 이후 또는 주말 및 공휴일에는 익일 처리하는 것을 원칙으로 합니다.<br/>
              <br/> 
              나. 개인정보에 대한 신고·상담이 필요하신 경우에는 정보통신부 산하 공공기관인 한국정보보호진흥원(KISA)내 개인정보침해신고센터 및 기타 관련기관으로 문의하시기 바랍니다. <br/>
              경찰청<br/>
              사이버안전국   홈페이지  http://cyberbureau.police.go.kr<br/> 
              전화  (국번없이) 182 <br/>
              대검찰청<br/>
              사이버수사과  홈페이지  http://spo.go.kr <br/>
              전화  (국번없이) 1301 <br/>
              개인정보 침해신고센터<br/>
              (한국인터넷 진흥원 운영)  홈페이지  http://privacy.kisa.or.kr <br/>
              전화  (국번없이) 118 <br/>
              개인정보 분쟁조정위원회  홈페이지  http://kopico.go.kr <br/>
              전화  1833-6972<br/>
            </div>
            <div>
              <p className="tit">12. 고지의 의무</p> 
              현 개인정보처리방침은 2008년 06월 08일에 최초로 제정된 내용이며 정부의 정책 또는 보안기술의 변경에 따라 내용의 추가 삭제 및 수정이 있을 시에는 최소 7일 전부터 홈페이지의 '공지사항' 란을 통해 고지할 것입니다. <br/>
            </div>
          </div>
        </div>
      </div>
      <div id="data-board" className={`data-board-container`}>
        <div className="data-board">
          <form className="container" onSubmit={handleSubmit}>
            <div className="data-box">
              <div className="data-item flex-justfy-content-center">
                <div className="flex align-items-center title">이 름</div>
              </div>
              <div className="data-item">
                <div className="flex align-items-center">
                  <input type="text" id="p_name_f" className="input_text" ref={nameRef} value={pName}
                  onChange={handleChange}
                  /*onChange={(e) => setName(e.target.value)}  */
                  style={{ width: "220px", imeMode: "active" }}
                  maxLength={30} placeholder="이름을 입력하세요" autoComplete="off" />
                </div>
              </div>
              <div className="data-item flex-justfy-content-center">
                <div className="flex align-items-center title">연 락 처</div>
              </div>
              <div className="data-item">              
                <div className="flex align-items-center">
                  <input type="text" name="phone" ref={cellNumRef} value={pCellNum} onChange={(e) => {
                    const regex = /^[0-9\b -]{0,13}$/;
                    if (regex.test(e.target.value)) {
                      setCellNum(e.target.value.replace(/-/g, ''));
                    }
                  }} 
                  onBlur={handleBlur}
                  style={{ width: "220px", imeMode: "active" }} maxLength={11} placeholder="휴대폰 '-' 없이 입력하세요" autoComplete="off" />
                </div>
              </div>
              <div className="data-item flex-justfy-content-center">
                <div className="flex align-items-center title">나 이</div>
              </div>
              <div className="data-item">
                <div className="flex align-items-center">
                  {ageList.map((value, index) => (
                    <label key={index} className="input-style">
                        <input type="radio" name="pAge" value={value} onChange={inputboxHandler} checked={pAge === value}/>{value}대
                    </label>
                  ))}
                  {/*
                  <select id="p_age" name="p_age" value={pAge} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setAge(Number(e.target.value))}>
                    {ageList.map((value, index) => (
                      <option key={index} value={value}>{value}대</option>
                    ))}
                  </select>
                  */}
                </div>
              </div>
              <div className="data-item flex-justfy-content-center">
                <div className="flex align-items-center title">성 별</div>
              </div>
              <div className="data-item">
                <div className="flex align-items-center">
                  {genderList.map((value, index) => (
                    <label key={index} className="input-style">
                        <input type="radio" name="pGender" value={value.value} onChange={inputboxHandler} checked={pGender === value.value}/>{value.label}
                    </label>
                  ))}
                  {/*
                  <select id="p_gender" name="p_gender" value={pGender} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setGender(e.target.value)}>
                    {genderList.map((value, index) => (
                      <option key={index} value={value.value}>{value.label}</option>
                    ))}
                  </select>
                  */}
                </div>
              </div>
            </div>

            <div className="send-data">
              <div className="private">
                <input type='checkbox' id="pPrivate" checked={pPrivate === "Y"} ref={privateCheckRef} onChange={e => setPrivate(e.target.checked ? "Y" : "N")} /> 
                <label htmlFor="pPrivate"> 개인정보 수집 및 활용동의 </label> <span style={{fontWeight:700}} onClick={onClickToggle} >[자세히 보기]</span>
              </div>
              <button type="submit" className="button">무료상담 신청하기</button>
            </div>
          </form>
        </div>
      </div>
    </>
    
  );
};

export default DataBoard;
